<template>
  <div>
    <el-dialog
      class="dialog-container"
      :visible.sync="addDialog"
      :title.sync="title"
      @close="handleCancel"
      width="60%"
      :modal-append-to-body="false"
      @open="beforeOpenDialog"
    >
      <el-form
        ref="addFrom"
        :model="addFrom"
        :rules="addRules"
        label-width="100px"
      >
        <el-form-item
          label="权益编号"
          prop="rightsCode"
        >
          <el-input
            :disabled="title === '编辑会员权益'"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            maxlength="99"
            show-word-limit
            width="40%"
            v-model="addFrom.rightsCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="权益名称"
          prop="rightsName"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            maxlength="99"
            show-word-limit
            v-model="addFrom.rightsName"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="描述文案"
          prop="description"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            maxlength="999"
            show-word-limit
            v-model="addFrom.description"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="客户端类型"
          prop="clientTypes"
        >
          <el-checkbox-group v-model="addFrom.clientTypes">
            <el-checkbox
              v-for="item in clientTypes"
              :key="item.dictKey"
              :label="item.dictKey"
            >{{ item.dictValue
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          label="限制参数"
          prop="limitParams"
        >
          <el-button
            type="primary"
            size="small"
            @click="addLimitParams"
            :disabled="selectedParams.length >= limitParams.length"
            style="margin-bottom: 10px;"
          >添加限制参数</el-button>
          <div
            v-for="(item, index) in selectedParams"
            :key="item.dictKey"
            style="display: flex;margin-bottom: 10px;"
          >
            <el-select
              :value="item.dictKey"
              :placeholder="item.dictValue"
              style="width: 50%;margin-right: 10px;"
              @input="handleLimitParamsChange($event, item, index)"
            >
              <el-option
                v-for="option in limitParams"
                :key="option.dictKey"
                :label="option.dictValue"
                :value="option.dictKey"
                :disabled="isLimitParamSelected(option.dictKey, item)"
              ></el-option>
            </el-select>
            <el-button
              icon="el-icon-delete"
              style="color: #ff0000;"
              type="text"
              size="small"
              @click="handleLimitParamsDel(item, index)"
            >删除</el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="权益状态"
          prop="state"
        >
          <el-radio-group v-model="addFrom.state">
            <el-radio :label="1">生效</el-radio>
            <el-radio :label="0">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item
          label="备注"
          prop="remark"
        >
          <el-input
            type="textarea"
            width="40%"
            :autosize="{ minRows: 2, maxRows: 10000 }"
            maxlength="9999"
            show-word-limit
            v-model="addFrom.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleCancel">取 消</el-button>
        <el-button
          type="primary"
          @click="handleConfirm"
        >保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Message from '@/components/Message';
import { getLimitParams, getClientType, addMemberRightLocal, editMemberRightLocal } from '@/api/memberNew/memberRight.js';
export default {
  name: 'WebSassMemberRightAddDialog',
  props: {
    /** 对话框的显隐 */
    addDialog: {
      type: Boolean,
      default: false
    },
    /** 添加或者编辑的表单 */
    addFrom: {
      type: Object,
      default: () => {
        return {
          id: '',
          rightsCode: '',
          rightsName: '',
          clientTypes: [],
          description: '',
          limitParams: '',
          state: '',
          remark: ''
        };
      }
    },
    /** 对话框标题 */
    title: {
      type: String,
      default: '新增会员权益'
    }
  },
  computed: {
    /** 对话框的显隐 */
    dialogVisible: {
      get() {
        return this.addDialog;
      }
    }
  },
  data() {
    return {
      /** 限制参数选项列表 */
      limitParams: [],
      /** 已选择的限制参数列表 */
      selectedParams: [],
      /** 客户端类型 */
      clientTypes: '',
      /** 表单规则 */
      addRules: {
        rightsCode: [
          { required: true, message: '请输入权益编号', trigger: 'blur' },
          { min: 1, max: 99, message: '长度在 1 到 99 个字符', trigger: 'blur' }
        ],
        rightsName: [
          { required: true, message: '请输入权益名称', trigger: 'blur' },
          { min: 1, max: 99, message: '长度在 1 到 99 个字符', trigger: 'blur' }
        ],
        clientTypes: [{ required: true, message: '请选择客户端类型', trigger: 'blur' }],
        state: [{ required: true, message: '请选择权益状态', trigger: 'blur' }]
      }
    };
  },

  methods: {
    /** 打开对话框之前 */
    async beforeOpenDialog() {
      console.log('打开对话框之前回填的数据', this.addFrom);
      try {
        /** 同时获取限制参数和客户端类型 */
        const [limitParamsRes, clientTypeRes] = await Promise.all([getLimitParams(), getClientType()]);

        if (limitParamsRes.data.code === 200) {
          console.log('限制参数', limitParamsRes.data.data[0].children);
          // 设置限制参数列表
          this.limitParams = limitParamsRes.data.data[0].children;

          this.selectedParams = [];

          if (this.addFrom.limitParams && this.addFrom.limitParams.length) {
            this.selectedParams = this.addFrom.limitParams.map((param) => {
              const option = this.limitParams.find((item) => item.dictKey === param.dictKey);
              return {
                dictKey: param.dictKey,
                dictValue: option ? option.dictValue : param.dictValue
              };
            });
          }
        } else {
          Message.error(limitParamsRes.message);
        }

        if (clientTypeRes.data.code === 200) {
          console.log('客户端类型', clientTypeRes.data.data[0].children);
          this.clientTypes = clientTypeRes.data.data[0].children;
        } else {
          Message.error(clientTypeRes.message);
        }
      } catch (error) {
        console.error('获取数据失败', error);
        Message.error('获取数据失败');
      }
    },
    /** 点击打开限制参数按钮事件 */
    addLimitParams() {
      const availableParams = this.limitParams.filter((item) => !this.selectedParams.some((param) => param.dictKey === item.dictKey));

      if (availableParams.length > 0) {
        this.selectedParams.push({
          dictKey: availableParams[0].dictKey,
          dictValue: availableParams[0].dictValue
        });
      }
    },
    /** 删除限制参数按钮事件 */
    handleLimitParamsDel(item, index) {
      this.selectedParams.splice(index, 1);
    },
    /** 限制参数选择变化事件 */
    handleLimitParamsChange(value, item, index) {
      const selectedOption = this.limitParams.find((option) => option.dictKey === value);

      if (selectedOption) {
        // 直接修改选中项的值
        this.$set(this.selectedParams, index, {
          dictKey: selectedOption.dictKey,
          dictValue: selectedOption.dictValue
        });
      }
    },
    /** 判断限制参数是否已被选择 */
    isLimitParamSelected(dictKey, currentItem) {
      return this.selectedParams.some((item) => item.dictKey === dictKey && item !== currentItem);
    },
    /** 对话框关闭按钮 */
    handleCancel() {
      /** 清理表单验证规则 */
      this.$refs.addFrom.clearValidate();
      /** 先清理数据再关闭对话框 */
      this.addFrom = {
        rightsCode: '',
        rightsName: '',
        clientTypes: [],
        description: '',
        limitParams: [],
        state: '',
        review_status: '',
        remark: ''
      };
      this.selectedParams = [];
      this.limitParams = [];
      this.$emit('update:addDialog', false);
    },
    /** 确定添加的事件 */
    handleConfirm() {
      /** 验证表单是否通过 */
      this.$refs.addFrom.validate(async (valid) => {
        if (valid) {
          /** 判断是新增还是编辑 */
          if (this.title === '编辑会员权益') {
            console.log('编辑会员权益', this.addFrom);
            /** 处理数据 */
            this.addFrom.clientTypes = this.addFrom.clientTypes.join(',');
            this.addFrom.limitParams = this.selectedParams.map((item) => item.dictKey).join(',');
            console.log('addForm', this.addFrom);
            /** 调用接口 */
            const { data } = await editMemberRightLocal(this.addFrom);
            console.log('编辑会员权益接口的响应', data);
            /** 如果成功提示用户 */
            if (data.code === 200) {
              Message.success('修改会员权益成功');
            }
            /** 关闭对话框 */
            this.handleCancel();
            /** 通知更新数据 */
            this.$emit('updateData');
          } else {
            /** 是新增 */
            /** 处理数据 */
            const addParams = { ...this.addFrom };

            addParams.clientTypes = addParams.clientTypes.join(',');
            addParams.limitParams = this.selectedParams.map((item) => item.dictKey).join(',');
            console.log('addParams', addParams);
            /** 调用接口 */
            const { data } = await addMemberRightLocal(addParams);
            console.log('添加会员权益接口的响应', data);
            /** 如果成功提示用户 */
            if (data.code === 200) {
              Message.success('添加成功');
            }
            /** 关闭对话框 */
            this.handleCancel();
            /** 通知更新数据 */
            this.$emit('updateData');
          }
        } else {
          Message.error('请检查表单是否填写完整');
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-container {
  ::v-deep .el-textarea__inner {
    padding-right: 55px !important;
    max-height: 100px !important;
  }
}
</style>